import { BreadcrumbProvider, BreadcrumbItem } from "./breadcrumb";
import { LocalizationService } from "../../localization/localization";

export class BreadcrumbHarnessProvider implements BreadcrumbProvider {
  private items: BreadcrumbItem[];
  private update: () => {};
  // @ngInject
  constructor(private $state: ng.ui.IStateService, private sdLocalizationService: LocalizationService) {
    this.construct();
  }
  private construct() {
    this.items = [];
    let currentState: any = this.$state.$current;
    if (currentState && currentState.self.name) {
      if (currentState.self.navDisplayNameLocApp) {
        if (!currentState.self.navDisplayNameLocKey) {
          throw new Error("The localization key is missing, can't fetch the display name for state");
        } else {
          let displayName = this.sdLocalizationService.getLocalizedString(
            currentState.self.navDisplayNameLocApp,
            currentState.self.navDisplayNameLocKey
          );
          this.items.unshift({ displayName: displayName, type: "state", link: currentState.self.name });
        }
      }
    }
    this.items.unshift(
      {
        displayName: "prefix1",
        type: "url",
        link: "https://www.google.com/"
      },
      {
        displayName: "prefix2",
        type: "url",
        link: "https://www.google.com/"
      }
    );
  }
  public registerUpdater(updateFn: () => {}) {
    this.update = updateFn;
    this.update();
  }
  public get() {
    return this.items;
  }
}

export class BreadcrumbHarnessController {
  public provider: BreadcrumbProvider;
  // @ngInject
  constructor(private $state: ng.ui.IStateService, private sdLocalizationService: LocalizationService) {
    this.provider = new BreadcrumbHarnessProvider($state, sdLocalizationService);
  }
}
